module.exports = __webpack_public_path__ + "img/204.87b5fdfe.jpg";